//
// feature-app.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

((() => {
    angular.module('curalate').factory('FEATURES_UTILS', ['$location', $location => ({
        getPageParams() {
            return $location.search();
        },

        setListAllParam(all) {
            $location.search('listAll', all);
        },

        setViewParam(view) {
            $location.search('view', view);
        },

        setClientParam(client) {
            $location.search('client', client);
        },

        setFeatureParam(feature) {
            $location.search('feature', feature);
        },

        viewNames: {
            features: {
                name: 'Features',
            },
            clientfeatures: {
                name: 'Client Features',
            },
            clientswithfeature: {
                name: 'Clients With Feature',
            },
        },
    })]);
}))();
